"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Account extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'account';
        this._username = initParams.username;
        this._billingEmail = initParams.billing_email;
        this._god = initParams.god;
        this._organisationId = initParams.organisation_id;
        this._inDemo = initParams.in_demo;
        this._alertEmail = initParams.alert_email;
        this._alertSms = initParams.alert_sms;
        this._alertToast = initParams.alert_toast;
        this._colour = initParams.colour;
        this._frequency = initParams.frequency;
        this._mfaEnabled = initParams.mfa_enabled;
        this._jobRole = initParams.job_role;
        this._profilePicture = initParams.profile_picture;
        this._profilePictureThumbnail = initParams.profile_picture_thumbnail;
        this._name = initParams.name;
        this._tour = initParams.tour;
        this._tourPreferences = initParams.tour_preferences;
        this._themes = (0, util_1.camelArray)(initParams.themes);
        this._theme = initParams.theme;
        this._customTheme = initParams.custom_theme;
        this._darkLight = initParams.dark_light;
        this._ignoredAssets = (0, util_1.camelArray)(initParams.ignored_assets);
        this._ignoreAll = initParams.ignore_all;
        this._ignoreAssetsWithFilter = initParams.ignore_assets_with_filter;
        this._unignoreAll = initParams.unignore_all;
        this._ignoreAssets = (0, util_1.camelArray)(initParams.ignore_assets);
        this._unignoreAssets = (0, util_1.camelArray)(initParams.unignore_assets);
        this._ignoredSites = (0, util_1.camelArray)(initParams.ignored_sites);
        this._organisationName = initParams.organisation_name;
        this._orgPermission = initParams.org_permission;
        this._orgWebsite = initParams.org_website;
        this._orgPhone = initParams.org_phone;
        this._orgEmail = initParams.org_email;
        this._orgAddress = initParams.org_address;
        this._logoImage = initParams.logo_image;
        this._logoImageThumbnail = initParams.logo_image_thumbnail;
        this._squareLogoImage = initParams.square_logo_image;
        this._squareLogoImageThumbnail = initParams.square_logo_image_thumbnail;
        this._orgMfaEnforced = initParams.org_mfa_enforced;
        this._noSites = initParams.no_sites;
        this._noAssets = initParams.no_assets;
        this._receiveAuditEmails = initParams.receive_audit_emails;
        this._sitesCount = initParams.sites_count;
        this._siteGroupsCount = initParams.site_groups_count;
        this._stripeId = initParams.stripe_id;
        this._features = (0, util_1.camelArray)(initParams.features);
        this._customKpiDefaults = (0, util_1.camelArray)(initParams.custom_kpi_defaults);
        this._skusConnected = (0, util_1.camelArray)(initParams.skus_connected);
        this._dcActiveSession = initParams.dc_active_session;
        this._subscriptions = initParams.subscriptions;
        this._invoices = initParams.invoices;
        this._delinquent = initParams.delinquent;
        this._orgOverridePerms = initParams.org_override_perms;
        this._sitesLimitedTo = (0, util_1.camelArray)(initParams.sites_limited_to);
        this._defaultOccupancySchedule = initParams.default_occupancy_schedule;
        this._whiteLabel = initParams.white_label;
        this._inheritWhiteLabelFrom = initParams.inherit_white_label_from;
        this._whiteLabelTheme = initParams.white_label_theme;
        this._whiteLabelCustomTheme = initParams.white_label_custom_theme;
        this._muteNotificationSound = initParams.mute_notification_sound;
        this._dashboardTier = initParams.dashboard_tier;
        this._dashboardTierFrequency = initParams.dashboard_tier_frequency;
        this._tierAvailableFeatures = (0, util_1.camelArray)(initParams.tier_available_features);
        this._allTierFeatures = (0, util_1.camelArray)(initParams.all_tier_features);
        this._subPaymentExempt = initParams.sub_payment_exempt;
        this._globalFeatures = (0, util_1.camelArray)(initParams.global_features);
    }
    set username(value) {
        console.error('Do not set objects this way');
    }
    setUsername(value) {
        return this.dataService.updateAccount(this.id, { username: value }, this);
    }
    get username() {
        return this._username;
    }
    set billingEmail(value) {
        console.error('Do not set objects this way');
    }
    setBillingEmail(value) {
        return this.dataService.updateAccount(this.id, { billing_email: value }, this);
    }
    get billingEmail() {
        return this._billingEmail;
    }
    set god(value) {
        console.error('Do not set objects this way');
    }
    setGod(value) {
        return this.dataService.updateAccount(this.id, { god: value }, this);
    }
    get god() {
        return this._god;
    }
    set organisationId(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationId(value) {
        return this.dataService.updateAccount(this.id, { organisation_id: value }, this);
    }
    get organisationId() {
        return this._organisationId;
    }
    set inDemo(value) {
        console.error('Do not set objects this way');
    }
    setInDemo(value) {
        return this.dataService.updateAccount(this.id, { in_demo: value }, this);
    }
    get inDemo() {
        return this._inDemo;
    }
    set alertEmail(value) {
        console.error('Do not set objects this way');
    }
    setAlertEmail(value) {
        return this.dataService.updateAccount(this.id, { alert_email: value }, this);
    }
    get alertEmail() {
        return this._alertEmail;
    }
    set alertSms(value) {
        console.error('Do not set objects this way');
    }
    setAlertSms(value) {
        return this.dataService.updateAccount(this.id, { alert_sms: value }, this);
    }
    get alertSms() {
        return this._alertSms;
    }
    set alertToast(value) {
        console.error('Do not set objects this way');
    }
    setAlertToast(value) {
        return this.dataService.updateAccount(this.id, { alert_toast: value }, this);
    }
    get alertToast() {
        return this._alertToast;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    setColour(value) {
        return this.dataService.updateAccount(this.id, { colour: value }, this);
    }
    get colour() {
        return this._colour;
    }
    set frequency(value) {
        console.error('Do not set objects this way');
    }
    setFrequency(value) {
        return this.dataService.updateAccount(this.id, { frequency: value }, this);
    }
    get frequency() {
        return this._frequency;
    }
    set mfaEnabled(value) {
        console.error('Do not set objects this way');
    }
    setMfaEnabled(value) {
        return this.dataService.updateAccount(this.id, { mfa_enabled: value }, this);
    }
    get mfaEnabled() {
        return this._mfaEnabled;
    }
    set jobRole(value) {
        console.error('Do not set objects this way');
    }
    setJobRole(value) {
        return this.dataService.updateAccount(this.id, { job_role: value }, this);
    }
    get jobRole() {
        return this._jobRole;
    }
    set profilePicture(value) {
        console.error('Do not set objects this way');
    }
    setProfilePicture(value) {
        return this.dataService.updateAccount(this.id, { profile_picture: value }, this);
    }
    get profilePicture() {
        return this._profilePicture;
    }
    set profilePictureThumbnail(value) {
        console.error('Do not set objects this way');
    }
    setProfilePictureThumbnail(value) {
        return this.dataService.updateAccount(this.id, { profile_picture_thumbnail: value }, this);
    }
    get profilePictureThumbnail() {
        return this._profilePictureThumbnail;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateAccount(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set tour(value) {
        console.error('Do not set objects this way');
    }
    setTour(value) {
        return this.dataService.updateAccount(this.id, { tour: value }, this);
    }
    get tour() {
        return this._tour;
    }
    set tourPreferences(value) {
        console.error('Do not set objects this way');
    }
    setTourPreferences(value) {
        return this.dataService.updateAccount(this.id, { tour_preferences: value }, this);
    }
    get tourPreferences() {
        return this._tourPreferences;
    }
    set themes(value) {
        console.error('Do not set objects this way');
    }
    setThemes(value) {
        return this.dataService.updateAccount(this.id, { themes: (0, util_1.snakeArray)(value) }, this);
    }
    get themes() {
        return this._themes;
    }
    set theme(value) {
        console.error('Do not set objects this way');
    }
    setTheme(value) {
        return this.dataService.updateAccount(this.id, { theme: value }, this);
    }
    get theme() {
        return this._theme;
    }
    set customTheme(value) {
        console.error('Do not set objects this way');
    }
    setCustomTheme(value) {
        return this.dataService.updateAccount(this.id, { custom_theme: value }, this);
    }
    get customTheme() {
        return this._customTheme;
    }
    set darkLight(value) {
        console.error('Do not set objects this way');
    }
    setDarkLight(value) {
        return this.dataService.updateAccount(this.id, { dark_light: value }, this);
    }
    get darkLight() {
        return this._darkLight;
    }
    set ignoredAssets(value) {
        console.error('Do not set objects this way');
    }
    setIgnoredAssets(value) {
        return this.dataService.updateAccount(this.id, { ignored_assets: (0, util_1.snakeArray)(value) }, this);
    }
    get ignoredAssets() {
        return this._ignoredAssets;
    }
    set ignoreAll(value) {
        console.error('Do not set objects this way');
    }
    setIgnoreAll(value) {
        return this.dataService.updateAccount(this.id, { ignore_all: value }, this);
    }
    get ignoreAll() {
        return this._ignoreAll;
    }
    set ignoreAssetsWithFilter(value) {
        console.error('Do not set objects this way');
    }
    setIgnoreAssetsWithFilter(value) {
        return this.dataService.updateAccount(this.id, { ignore_assets_with_filter: value }, this);
    }
    get ignoreAssetsWithFilter() {
        return this._ignoreAssetsWithFilter;
    }
    set unignoreAll(value) {
        console.error('Do not set objects this way');
    }
    setUnignoreAll(value) {
        return this.dataService.updateAccount(this.id, { unignore_all: value }, this);
    }
    get unignoreAll() {
        return this._unignoreAll;
    }
    set ignoreAssets(value) {
        console.error('Do not set objects this way');
    }
    setIgnoreAssets(value) {
        return this.dataService.updateAccount(this.id, { ignore_assets: (0, util_1.snakeArray)(value) }, this);
    }
    get ignoreAssets() {
        return this._ignoreAssets;
    }
    set unignoreAssets(value) {
        console.error('Do not set objects this way');
    }
    setUnignoreAssets(value) {
        return this.dataService.updateAccount(this.id, { unignore_assets: (0, util_1.snakeArray)(value) }, this);
    }
    get unignoreAssets() {
        return this._unignoreAssets;
    }
    set ignoredSites(value) {
        console.error('Do not set objects this way');
    }
    setIgnoredSites(value) {
        return this.dataService.updateAccount(this.id, { ignored_sites: (0, util_1.snakeArray)(value) }, this);
    }
    get ignoredSites() {
        return this._ignoredSites;
    }
    set organisationName(value) {
        console.error('Do not set objects this way');
    }
    setOrganisationName(value) {
        return this.dataService.updateAccount(this.id, { organisation_name: value }, this);
    }
    get organisationName() {
        return this._organisationName;
    }
    set orgPermission(value) {
        console.error('Do not set objects this way');
    }
    setOrgPermission(value) {
        return this.dataService.updateAccount(this.id, { org_permission: value }, this);
    }
    get orgPermission() {
        return this._orgPermission;
    }
    set orgWebsite(value) {
        console.error('Do not set objects this way');
    }
    setOrgWebsite(value) {
        return this.dataService.updateAccount(this.id, { org_website: value }, this);
    }
    get orgWebsite() {
        return this._orgWebsite;
    }
    set orgPhone(value) {
        console.error('Do not set objects this way');
    }
    setOrgPhone(value) {
        return this.dataService.updateAccount(this.id, { org_phone: value }, this);
    }
    get orgPhone() {
        return this._orgPhone;
    }
    set orgEmail(value) {
        console.error('Do not set objects this way');
    }
    setOrgEmail(value) {
        return this.dataService.updateAccount(this.id, { org_email: value }, this);
    }
    get orgEmail() {
        return this._orgEmail;
    }
    set orgAddress(value) {
        console.error('Do not set objects this way');
    }
    setOrgAddress(value) {
        return this.dataService.updateAccount(this.id, { org_address: value }, this);
    }
    get orgAddress() {
        return this._orgAddress;
    }
    set logoImage(value) {
        console.error('Do not set objects this way');
    }
    setLogoImage(value) {
        return this.dataService.updateAccount(this.id, { logo_image: value }, this);
    }
    get logoImage() {
        return this._logoImage;
    }
    set logoImageThumbnail(value) {
        console.error('Do not set objects this way');
    }
    setLogoImageThumbnail(value) {
        return this.dataService.updateAccount(this.id, { logo_image_thumbnail: value }, this);
    }
    get logoImageThumbnail() {
        return this._logoImageThumbnail;
    }
    set squareLogoImage(value) {
        console.error('Do not set objects this way');
    }
    setSquareLogoImage(value) {
        return this.dataService.updateAccount(this.id, { square_logo_image: value }, this);
    }
    get squareLogoImage() {
        return this._squareLogoImage;
    }
    set squareLogoImageThumbnail(value) {
        console.error('Do not set objects this way');
    }
    setSquareLogoImageThumbnail(value) {
        return this.dataService.updateAccount(this.id, { square_logo_image_thumbnail: value }, this);
    }
    get squareLogoImageThumbnail() {
        return this._squareLogoImageThumbnail;
    }
    set orgMfaEnforced(value) {
        console.error('Do not set objects this way');
    }
    setOrgMfaEnforced(value) {
        return this.dataService.updateAccount(this.id, { org_mfa_enforced: value }, this);
    }
    get orgMfaEnforced() {
        return this._orgMfaEnforced;
    }
    set noSites(value) {
        console.error('Do not set objects this way');
    }
    setNoSites(value) {
        return this.dataService.updateAccount(this.id, { no_sites: value }, this);
    }
    get noSites() {
        return this._noSites;
    }
    set noAssets(value) {
        console.error('Do not set objects this way');
    }
    setNoAssets(value) {
        return this.dataService.updateAccount(this.id, { no_assets: value }, this);
    }
    get noAssets() {
        return this._noAssets;
    }
    set receiveAuditEmails(value) {
        console.error('Do not set objects this way');
    }
    setReceiveAuditEmails(value) {
        return this.dataService.updateAccount(this.id, { receive_audit_emails: value }, this);
    }
    get receiveAuditEmails() {
        return this._receiveAuditEmails;
    }
    set sitesCount(value) {
        console.error('Do not set objects this way');
    }
    setSitesCount(value) {
        return this.dataService.updateAccount(this.id, { sites_count: value }, this);
    }
    get sitesCount() {
        return this._sitesCount;
    }
    set siteGroupsCount(value) {
        console.error('Do not set objects this way');
    }
    setSiteGroupsCount(value) {
        return this.dataService.updateAccount(this.id, { site_groups_count: value }, this);
    }
    get siteGroupsCount() {
        return this._siteGroupsCount;
    }
    set stripeId(value) {
        console.error('Do not set objects this way');
    }
    setStripeId(value) {
        return this.dataService.updateAccount(this.id, { stripe_id: value }, this);
    }
    get stripeId() {
        return this._stripeId;
    }
    set features(value) {
        console.error('Do not set objects this way');
    }
    setFeatures(value) {
        return this.dataService.updateAccount(this.id, { features: (0, util_1.snakeArray)(value) }, this);
    }
    get features() {
        return this._features;
    }
    set customKpiDefaults(value) {
        console.error('Do not set objects this way');
    }
    setCustomKpiDefaults(value) {
        return this.dataService.updateAccount(this.id, { custom_kpi_defaults: (0, util_1.snakeArray)(value) }, this);
    }
    get customKpiDefaults() {
        return this._customKpiDefaults;
    }
    set skusConnected(value) {
        console.error('Do not set objects this way');
    }
    setSkusConnected(value) {
        return this.dataService.updateAccount(this.id, { skus_connected: (0, util_1.snakeArray)(value) }, this);
    }
    get skusConnected() {
        return this._skusConnected;
    }
    set dcActiveSession(value) {
        console.error('Do not set objects this way');
    }
    setDcActiveSession(value) {
        return this.dataService.updateAccount(this.id, { dc_active_session: value }, this);
    }
    get dcActiveSession() {
        return this._dcActiveSession;
    }
    set subscriptions(value) {
        console.error('Do not set objects this way');
    }
    setSubscriptions(value) {
        return this.dataService.updateAccount(this.id, { subscriptions: value }, this);
    }
    get subscriptions() {
        return this._subscriptions;
    }
    set invoices(value) {
        console.error('Do not set objects this way');
    }
    setInvoices(value) {
        return this.dataService.updateAccount(this.id, { invoices: value }, this);
    }
    get invoices() {
        return this._invoices;
    }
    set delinquent(value) {
        console.error('Do not set objects this way');
    }
    setDelinquent(value) {
        return this.dataService.updateAccount(this.id, { delinquent: value }, this);
    }
    get delinquent() {
        return this._delinquent;
    }
    set orgOverridePerms(value) {
        console.error('Do not set objects this way');
    }
    setOrgOverridePerms(value) {
        return this.dataService.updateAccount(this.id, { org_override_perms: value }, this);
    }
    get orgOverridePerms() {
        return this._orgOverridePerms;
    }
    set sitesLimitedTo(value) {
        console.error('Do not set objects this way');
    }
    setSitesLimitedTo(value) {
        return this.dataService.updateAccount(this.id, { sites_limited_to: (0, util_1.snakeArray)(value) }, this);
    }
    get sitesLimitedTo() {
        return this._sitesLimitedTo;
    }
    set defaultOccupancySchedule(value) {
        console.error('Do not set objects this way');
    }
    setDefaultOccupancySchedule(value) {
        return this.dataService.updateAccount(this.id, { default_occupancy_schedule: value }, this);
    }
    get defaultOccupancySchedule() {
        return this._defaultOccupancySchedule;
    }
    set whiteLabel(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabel(value) {
        return this.dataService.updateAccount(this.id, { white_label: value }, this);
    }
    get whiteLabel() {
        return this._whiteLabel;
    }
    set inheritWhiteLabelFrom(value) {
        console.error('Do not set objects this way');
    }
    setInheritWhiteLabelFrom(value) {
        return this.dataService.updateAccount(this.id, { inherit_white_label_from: value }, this);
    }
    get inheritWhiteLabelFrom() {
        return this._inheritWhiteLabelFrom;
    }
    set whiteLabelTheme(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabelTheme(value) {
        return this.dataService.updateAccount(this.id, { white_label_theme: value }, this);
    }
    get whiteLabelTheme() {
        return this._whiteLabelTheme;
    }
    set whiteLabelCustomTheme(value) {
        console.error('Do not set objects this way');
    }
    setWhiteLabelCustomTheme(value) {
        return this.dataService.updateAccount(this.id, { white_label_custom_theme: value }, this);
    }
    get whiteLabelCustomTheme() {
        return this._whiteLabelCustomTheme;
    }
    set muteNotificationSound(value) {
        console.error('Do not set objects this way');
    }
    setMuteNotificationSound(value) {
        return this.dataService.updateAccount(this.id, { mute_notification_sound: value }, this);
    }
    get muteNotificationSound() {
        return this._muteNotificationSound;
    }
    set dashboardTier(value) {
        console.error('Do not set objects this way');
    }
    setDashboardTier(value) {
        return this.dataService.updateAccount(this.id, { dashboard_tier: value }, this);
    }
    get dashboardTier() {
        return this._dashboardTier;
    }
    set dashboardTierFrequency(value) {
        console.error('Do not set objects this way');
    }
    setDashboardTierFrequency(value) {
        return this.dataService.updateAccount(this.id, { dashboard_tier_frequency: value }, this);
    }
    get dashboardTierFrequency() {
        return this._dashboardTierFrequency;
    }
    set tierAvailableFeatures(value) {
        console.error('Do not set objects this way');
    }
    setTierAvailableFeatures(value) {
        return this.dataService.updateAccount(this.id, { tier_available_features: (0, util_1.snakeArray)(value) }, this);
    }
    get tierAvailableFeatures() {
        return this._tierAvailableFeatures;
    }
    set allTierFeatures(value) {
        console.error('Do not set objects this way');
    }
    setAllTierFeatures(value) {
        return this.dataService.updateAccount(this.id, { all_tier_features: (0, util_1.snakeArray)(value) }, this);
    }
    get allTierFeatures() {
        return this._allTierFeatures;
    }
    set subPaymentExempt(value) {
        console.error('Do not set objects this way');
    }
    setSubPaymentExempt(value) {
        return this.dataService.updateAccount(this.id, { sub_payment_exempt: value }, this);
    }
    get subPaymentExempt() {
        return this._subPaymentExempt;
    }
    set globalFeatures(value) {
        console.error('Do not set objects this way');
    }
    setGlobalFeatures(value) {
        return this.dataService.updateAccount(this.id, { global_features: (0, util_1.snakeArray)(value) }, this);
    }
    get globalFeatures() {
        return this._globalFeatures;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateAccount(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = Account;
//# sourceMappingURL=account.js.map